module.exports = __webpack_public_path__ + "img/rect_wechat_group.ec3dc6bc.png";